;(function () {
    // inviterId 邀请者报名ID
    // sellerID 销售人员ID来自名片小程序，如果有这个id 生成海报时触发跳转名片小程序页面

    // 销售ID
    var sellerID = common.getUrlPara('sid') ||  common.getCookie('sellerID') || '';
    if(sellerID){
        common.setCookie('sellerID', sellerID)
    }

    // 名片活动ID
    var fissionId = common.getUrlPara('fissionId') ||  common.getCookie('fissionId') || '';
    if(fissionId){
        common.setCookie('fissionId', fissionId)
    }

    // 邀请者报名ID
    var inviterId = common.getUrlPara('inviterId') ||  common.getCookie('inviterId') || '';
    if(inviterId){
        common.setCookie('inviterId', inviterId)
    }
})();
